import { View } from 'backbone.marionette';
import template from './index.jst';
import './index.styl';

/**
 * @desc Streak View Class
 * This class using on league loin page ('/streak')
 */
export class StreakPlaceholderView extends View {
	get template() {
		return template;
	}

	get className() {
		return 'streak-page'
	}
}

export default StreakPlaceholderView;